import { Box } from "@mui/material"
import { PoweredBy } from "components/PoweredBy/PoweredBy"
import LanguageMenu from "./LanguageMenu"
import { useTranslation } from "react-i18next"
import { STATICS } from "api/api"

export const DevelopmentPage = () => {
    const { i18n, i18n: { language } } = useTranslation()

    return <Box sx={{ height: "100vh" }}>
        <Box sx={{ pt: { xs:2, lg: 5 }, px: { xs:2, lg: 5 }, height: { xs: "calc(100% - 50px)", lg: "calc(100% - 120px)" }, }}>
            <Box sx={{ display: 'flex', alignContent: 'center', justifyContent: "space-between" }}>
            <Box
                component="img"
                sx={{
                    height: { xs: 50, lg: 109 },
                    width: { xs: 100, lg: 229 },
                }}
                alt="The house from the offer."
                src={`${STATICS}/svg/estatetool-logo.svg`}
            />
            <LanguageMenu />
            </Box>
            <Box sx={{ display: 'flex', alignContent: 'center', flexDirection: 'column', height: "100%", justifyContent: "space-between", pt: { xs:2, lg: 0 } }}>
                <Box  sx={{ display: 'flex', alignContent: 'center', flexDirection: 'column', gap: '40px' }}>
                    <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                        <Box
                            component="img"
                            alt="The house from the offer."
                            src={`${STATICS}/svg/development-image.svg`}
                        />
                    </Box>
                    <Box sx={{ display: 'flex', alignContent: 'center', flexDirection: 'column', textAlign: 'center', gap: '16px' }}>
                        <h1 className="h1">{ developmentPage.desc[language] }</h1>
                        <Box className="paragraph1-regular" sx={{ display: 'flex', alignContent: 'center', flexDirection: 'column', textAlign: 'center', gap: '30px', maxWidth: "770px", alignSelf: 'center' }}>
                            <p>{ developmentPage.p1[language] }</p>
                            <p>{ developmentPage.p2[language] }</p>
                        </Box>
                    </Box>
                </Box>
                <PoweredBy />
            </Box>
        </Box>
    </Box>
}



const developmentPage = {
    desc: {
        "en": "We are building another estatetool home selector!",
        "da": "Vi bygger endnu en estatetool boligvælger!"
    },
    p1: {
        "en": "Soon an estatetool home selector will be launched here, which is your perfect tool for finding the home of your dreams. We work behind the scenes to create an experience that makes house hunting both more fun and easier.",
        "da": "Snart lanceres der en estatetool boligvælger her, som er dit perfekte værktøj til at finde drømmeboligen. Vi arbejder bag kulisserne for at skabe en oplevelse, der gør boligjagten både sjovere og lettere."
    },
    p2: {
        "en": "Thanks for your patience - it will definitely be worth the wait!",
        "da": "Tak for din tålmodighed - det bliver uden tvivl ventetiden værd!"
    }
}